// @flow

import * as React from "react";
import _ from "lodash";
import ComponentBuilder from "../components/organisms/ComponentBuilder";
import Tile from "../components/molecules/Tile";
import Icon from "../components/atoms/Icon";
import { ReactComponent as ActivateLogo } from "../../assets/images/activate-logo.svg";

type PropsType = {
    page: any,
    heroTitleSize: "heading-1" | "heading-2",
    showRelated?: boolean,
};

const SimpleContentPage = (props: PropsType): React.Node => {
    const { page } = props;
    const components =
        _.get(page, "acf.component_builder[0].component_builder") || [];
    return (
        <>
            <div>
                <ActivateLogo />

                <button className="primary-nav__controls__btn">
                    <Icon name="user" />
                </button>

                <button className="primary-nav__controls__btn">
                    <Icon name="cart" />
                </button>

                <button className="primary-nav__controls__btn">
                    <Icon name="search" />
                </button>

                <button className="primary-nav__controls__btn hide-for-md">
                    <Icon name="burger" />
                </button>
            </div>

            <div>
                <div className="page-content page-content--simple">
                    <div className="container-fluid">
                        <div
                            className="row center-xs"
                            style={{ textAlign: "left" }}
                        >
                            <div className="col-xs-12">
                                <div className="page-content__inner">
                                    <ComponentBuilder components={components} />
                                    <div className="row">
                                        <div className="col-md-7">
                                            <Tile
                                                expanded={true}
                                                variation="club"
                                                title="UTS Student design competition"
                                                description="Sed posuere consectetur est at lobortis. Praesent commodo cursus magna, vel scelerisque nisl"
                                                logo="https://s3-alpha-sig.figma.com/img/c7b6/3bd2/3b49ddb283a5462e95c634e916a34243?Expires=1633305600&Signature=LKfYvf9SVR5LZOoa8W08RF2brVcuns3j0dgYd7tQV0ux2U0pv3CfrEiPnXtDAnltyvQ7hlW90iVU6Th~SWBD-MOKS216BT4qUsU1LwVDLqchLSf9lh9dT29OgWUZ8CkBdMaTX9U-nWE2z8enzvmOt4ejvFIEYnpVt6AMXRUZzuwX3opF6Uhdu7YZgypFnmTmnGryNwxQroxeW2BYKmFLj5dtgY19gjLVWm8HPV2ppkDjWf4HZm17ilYogLOllAPMNYGfkTtv6hzlEby0ZJhm0g9X0iSwxAwdiLDe4tRf6gwud-XFMLNXldI4y-Kgx1b06LXwk6dZ3OlYWVToVFwySw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                                                image="https://s3-alpha-sig.figma.com/img/e2b8/9715/3e01d150180164d45ffdc441aabe8a83?Expires=1633305600&Signature=X~7KeHYXchiGSMM~85b8hXBYfbuZmazLyGm6KQfD-x9COOmRArmTLJZ2gQUP3EHeXLKSFRF5yqiaFE4vj4hBJp5UjLoe8OxCdTgdCWjgtKwlkSS0UE1nHIzdS4kMjwr-YYYmvWtacJngtozDLxXXbrvYOtzAZARbRjhDUgVhhEVa2Tf~caxLoRKtjrZsE3X0J7ju6v7uL1mwo~iwFxP3h~by1ZUqfz~vApRWpHPG2Nn-g6jKRH63EvVrwylos86merna8mJPigG-jr-9-MZFy6HKRLMRBn4zQ2HsypXaaX8uPnthcAMtyJwyCuedLUBYmCIIEt2UpYh-wU4F9iSYLQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                                                tags={["3 upcoming events"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <Tile
                                                expanded={true}
                                                variation="page"
                                                eyebrow="Closing Soon"
                                                title="UTS Student design competition"
                                                description="Sed posuere consectetur est at lobortis. Praesent commodo cursus magna, vel scelerisque nisl"
                                                image="https://s3-alpha-sig.figma.com/img/e2b8/9715/3e01d150180164d45ffdc441aabe8a83?Expires=1633305600&Signature=X~7KeHYXchiGSMM~85b8hXBYfbuZmazLyGm6KQfD-x9COOmRArmTLJZ2gQUP3EHeXLKSFRF5yqiaFE4vj4hBJp5UjLoe8OxCdTgdCWjgtKwlkSS0UE1nHIzdS4kMjwr-YYYmvWtacJngtozDLxXXbrvYOtzAZARbRjhDUgVhhEVa2Tf~caxLoRKtjrZsE3X0J7ju6v7uL1mwo~iwFxP3h~by1ZUqfz~vApRWpHPG2Nn-g6jKRH63EvVrwylos86merna8mJPigG-jr-9-MZFy6HKRLMRBn4zQ2HsypXaaX8uPnthcAMtyJwyCuedLUBYmCIIEt2UpYh-wU4F9iSYLQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <Tile
                                                expanded={true}
                                                variation="product"
                                                badge="$35.95"
                                                eyebrow="10% off for students"
                                                title="UTS Student design competition"
                                                description="Sed posuere consectetur est at lobortis. Praesent commodo cursus magna, vel scelerisque nisl"
                                                image="https://s3-alpha-sig.figma.com/img/e2b8/9715/3e01d150180164d45ffdc441aabe8a83?Expires=1633305600&Signature=X~7KeHYXchiGSMM~85b8hXBYfbuZmazLyGm6KQfD-x9COOmRArmTLJZ2gQUP3EHeXLKSFRF5yqiaFE4vj4hBJp5UjLoe8OxCdTgdCWjgtKwlkSS0UE1nHIzdS4kMjwr-YYYmvWtacJngtozDLxXXbrvYOtzAZARbRjhDUgVhhEVa2Tf~caxLoRKtjrZsE3X0J7ju6v7uL1mwo~iwFxP3h~by1ZUqfz~vApRWpHPG2Nn-g6jKRH63EvVrwylos86merna8mJPigG-jr-9-MZFy6HKRLMRBn4zQ2HsypXaaX8uPnthcAMtyJwyCuedLUBYmCIIEt2UpYh-wU4F9iSYLQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                                                tags={[
                                                    "More options available",
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

SimpleContentPage.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default SimpleContentPage;
